import { twMerge } from 'tailwind-merge'

export default function SaveSuccessIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={twMerge('size-4 fill-black', className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 13H8V14H3C2.73478 14 2.48043 13.8947 2.29289 13.7071C2.10536 13.5196 2 13.2652 2 13V3.00001C2 2.73479 2.10536 2.48044 2.29289 2.2929C2.48043 2.10537 2.73478 2.00001 3 2.00001H11C11.0658 1.9996 11.131 2.0122 11.192 2.03708C11.2529 2.06197 11.3083 2.09864 11.355 2.14501L13.855 4.64501C13.9013 4.69173 13.938 4.74714 13.9629 4.80806C13.9878 4.86898 14.0004 4.93421 14 5.00001V9.00001H13V5.20501L11 3.20501V5.00001C11 5.26523 10.8946 5.51958 10.7071 5.70712C10.5196 5.89465 10.2652 6.00001 10 6.00001H6C5.73478 6.00001 5.48043 5.89465 5.29289 5.70712C5.10536 5.51958 5 5.26523 5 5.00001V3.00001H3V13H5V9.00001C5 8.73479 5.10536 8.48044 5.29289 8.2929C5.48043 8.10537 5.73478 8.00001 6 8.00001H10V9.00001H6V13ZM10 3.00001H6V5.00001H10V3.00001ZM10.705 12L12 13.295L14.795 10.5L15.5 11.205L12 14.705L10 12.705L10.705 12Z"
      />
    </svg>
  )
}
